module.exports = __webpack_public_path__ + "static/media/cafe_popular_thumb_even.a3bb1958.webp";